<template>
  <section class="benefits-section">
    <div class="benefits-section__container">
      <!-- Section Header -->
      <div class="benefits-section__header">
        <h2 class="benefits-section__title">
          Es hora de enviar <span>mejores emails</span>
        </h2>
        <p class="benefits-section__subtitle">
          La plataforma todo-en-uno para validar, crear y enviar campañas de email marketing con IA.
        </p>
      </div>
      
      <!-- Benefits Grid -->
      <div class="benefits-section__grid">
        <!-- Benefit 1: Email Validation -->
        <div class="benefits-section__card">
          <div class="benefits-section__icon">
            <i class="pi pi-shield"></i>
          </div>
          <h3 class="benefits-section__stat">
            Reducción del 90% en correos rebotados
          </h3>
          <h4 class="benefits-section__headline">
            Elimina el estrés de presionar "Enviar"
          </h4>
          <p class="benefits-section__description">
            Limpia tus listas con nuestra Validación Quirúrgica en 5 pasos (SMTP, DNS y Sintaxis) y asegúrate de que cada mensaje llegue a una persona real, no a un buzón muerto.
          </p>
        </div>
        
        <!-- Benefit 2: AI Suite -->
        <div class="benefits-section__card">
          <div class="benefits-section__icon">
            <i class="pi pi-bolt"></i>
          </div>
          <h3 class="benefits-section__stat">
            3 veces más rápido al crear campañas con IA
          </h3>
          <h4 class="benefits-section__headline">
            Deja de mirar una página en blanco
          </h4>
          <p class="benefits-section__description">
            Genera plantillas profesionales y optimiza tus textos instantáneamente con nuestra Suite de IA. Acorta, alarga o ajusta el tono de tus mensajes para conectar mejor con tu audiencia.
          </p>
        </div>
        
        <!-- Benefit 3: Automation -->
        <div class="benefits-section__card">
          <div class="benefits-section__icon">
            <i class="pi pi-sync"></i>
          </div>
          <h3 class="benefits-section__stat">
            20+ horas ahorradas al mes en procesos manuales
          </h3>
          <h4 class="benefits-section__headline">
            Escala tu marketing en piloto automático
          </h4>
          <p class="benefits-section__description">
            Construye flujos de trabajo complejos con nuestro Visual Journey Builder. Envía el mensaje correcto en el momento preciso basándote en el comportamiento real de tus contactos.
          </p>
        </div>
        
        <!-- Benefit 4: Health Score -->
        <div class="benefits-section__card">
          <div class="benefits-section__icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <h3 class="benefits-section__stat">
            Visibilidad total de tu reputación de envío
          </h3>
          <h4 class="benefits-section__headline">
            Conoce la salud de tu lista antes de que sea tarde
          </h4>
          <p class="benefits-section__description">
            Monitorea tu Health Score (0-100) en tiempo real. Nuestro algoritmo analiza la calidad de tus contactos y te da recomendaciones accionables para proteger tu ROI.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// No reactive state needed for this static section
</script>

<style lang="scss" scoped>
@import '@/design-system/variables';

// ===========================================
// BENEFITS SECTION
// ===========================================

.benefits-section {
  padding: $tl-section-spacing 0;
  background: #1a1412;
  position: relative;
  overflow: hidden;
}

.benefits-section__container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 $tl-space-6;
  position: relative;
  z-index: 1;
}

// ===========================================
// SECTION HEADER
// ===========================================

.benefits-section__header {
  text-align: center;
  margin-bottom: $tl-space-12;
}

.benefits-section__title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: $tl-font-weight-bold;
  color: $tl-white;
  margin-bottom: $tl-space-4;
  line-height: 1.2;
  
  span {
    color: $tl-action;
  }
}

.benefits-section__subtitle {
  font-size: $tl-font-size-lg;
  color: $tl-gray-400;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

// ===========================================
// BENEFITS GRID
// ===========================================

.benefits-section__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: $tl-space-8;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
}

// ===========================================
// BENEFIT CARD
// ===========================================

.benefits-section__card {
  text-align: left;
  padding: $tl-space-6 0;
  border-top: 2px solid $tl-gray-700;
  transition: border-color 0.3s ease;
  
  &:hover {
    border-color: $tl-action;
    
    .benefits-section__icon {
      color: $tl-action;
      transform: scale(1.1);
    }
  }
}

.benefits-section__icon {
  font-size: 2rem;
  color: $tl-gray-400;
  margin-bottom: $tl-space-5;
  transition: all 0.3s ease;
  
  i {
    display: block;
  }
}

.benefits-section__stat {
  font-size: $tl-font-size-lg;
  font-weight: $tl-font-weight-bold;
  color: $tl-white;
  margin-bottom: $tl-space-3;
  line-height: 1.3;
}

.benefits-section__headline {
  font-size: $tl-font-size-base;
  font-weight: $tl-font-weight-medium;
  color: $tl-action;
  margin-bottom: $tl-space-3;
  line-height: 1.4;
}

.benefits-section__description {
  font-size: $tl-font-size-sm;
  color: $tl-gray-400;
  line-height: 1.7;
  margin: 0;
}
</style>
